// Behaviors
// require('./behaviors/01.menu-mobile');
require("./behaviors/02.image-bg");
require("./behaviors/03.anchor-link");
require("./behaviors/03.back-top");
require("./behaviors/04.fancybox");
require("./behaviors/05.slide");
require("./behaviors/06.whatsapp");
require("./behaviors/07.carousel-banners-empreendimentos");
require("./behaviors/09.carousel-parceiros")
require("./behaviors/10.carousel-depoimentos")
require("./behaviors/20.masks");
